"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testArrayEquality = void 0;
var equal_1 = require("./equal");
/** @internal */
var testArrayEquality = function (testName, array1, array2) {
    test(testName, function () {
        expect((0, equal_1.eq)(array1, array2)).toBeTruthy();
    });
};
exports.testArrayEquality = testArrayEquality;
